import { Component, HostListener, Input } from '@angular/core';

import { DialogConfig, DialogRef, SimpleDialogData } from '../../models';


/**
 * @export
 * @class DialogComponent
 * @description SimpleDialogComponent: Generic component used as a template component within the DialogComponent;
 * supports: dynamic buttons, title, message and a display icon.
 */
@Component({
	selector: 'ac-simple-dialog',
	templateUrl: './simple-dialog.component.html',
	styleUrls: ['./simple-dialog.component.scss']
})
export class SimpleDialogComponent {
	@Input() public dialogData: SimpleDialogData;

	constructor(
		private config: DialogConfig,
		private dialogRef: DialogRef
	) {
		this.dialogData = config.data;
	}

	@HostListener('document:keydown.escape', ['$event']) public onKeydownHandler(event: KeyboardEvent): void {
		this.close();
	}

	/**
	 * @description onClick: event handler for the button click events. Invokes the appropriate callback from the given DialogData.
	 * @param {number} index: the index of the action to invoke.
	 */
	public onClick(index: number): void {
		if (this.dialogData.actions[index].callback) {
			this.dialogData.actions[index].callback();
		}
		if (!this.dialogData.actions[index].keepDialogOpen) {
			this.close();
		}
	}

	public close(): void {
		this.dialogRef.close();
	}
}

